/**
 * Copia um texto para a área de transferência.
 *
 * A API moderna só existe em contexto seguro (https ou localhost); num
 * servidor interno sem TLS ela simplesmente não está lá, e um `catch` vazio
 * deixaria o botão sem fazer nada e sem dizer nada. O `prompt` é a saída: o
 * texto aparece selecionado e a pessoa copia com Ctrl+C.
 */
export async function copiar(texto: string): Promise<void> {
  try {
    await navigator.clipboard.writeText(texto);
  } catch {
    window.prompt('Copie o link:', texto);
  }
}
